import { selectResCommitAdditionalInformation } from 'selectors/uiStateSelectors';
import actions from '@ehi/global-marketing-interface/lib/actions';

/**
 * Sets an additionalInformaiton field on GMI UI Reservation Commit state.
 * @param {object} newField - Field to be set in additionalInformaiton
 */
export const setResCommitAdditionalInformation = (newField) => (dispatch, getState) => {
  const state = getState();
  const currentFields = selectResCommitAdditionalInformation(state);
  const filterFields = currentFields.filter((field) => field && field.id === newField.id);

  const updatedFields = filterFields.length
    ? filterFields.map((item) => (item.id === newField.id ? { ...filterFields[0], ...newField } : item))
    : filterFields.concat(newField);

  return updatedFields.map(({ id, value }) =>
    dispatch(
      actions.reservations.commitState.set('additional_information', {
        additional_information: {
          id,
          value,
        },
      })
    )
  );
};
